import mediumZoom from 'medium-zoom';

const init = () => {
  const elements = document.querySelectorAll('.js-zoom-image');

  if (elements.length === 0) {
    return;
  }

  elements.forEach(element => {

    const image = element.querySelector('.js-zoom-image-target');

    const zoom = mediumZoom(image, {
      margin: 24,
      background: '#fff',
      scrollOffset: 0,
    });

    const triggerButton = element.querySelector('.js-zoom-image-trigger');

    triggerButton.addEventListener('click', () => {
      zoom.open();
    });
  });
};

export default init;
